import { Component, OnInit, NgZone } from '@angular/core';
import { AppHttpService } from '../app-http.service';
import { CartService } from '../cart/cart.service';
import { CheckoutService } from '../checkout/checkout.service';
import { SharedService } from '../shared.service';
import { CouponFieldData } from 'app/interfaces/CouponFieldData';
import * as moment from 'moment';
import { NavigationEnd, Router, Event } from '@angular/router';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  lotteries = null;
  totalPrice = 0;
  serviceFee = 0;
  basePrice = 0;
  discount = 0;
  backPay;
  public isLoggedIn: boolean = false;
  public isConfirmation: boolean;
  public lotteryNumber = null;
  public lotteryStartDate = null;

  constructor(
    private zone: NgZone,
    private httpService: AppHttpService,
    private cartService: CartService,
    private checkoutService: CheckoutService,
    private sharedService: SharedService,
    private router: Router
  ) {
    /*
     * Add this component as a reference
     * to global window object and make the
     * methods 'onTicketSelect()', 'setCoupon' and 'clearCoupon'
     * available outside of root element.
     */
    window['ngRef'] = {
      zone: this.zone,
      componentFn: [
        (value) => this.onTicketSelect(value),
        (coupon) => this.setCoupon(coupon),
        (clearedCoupon) => this.clearCoupon(clearedCoupon)
      ],
      component: this
    };
  }

  ngOnInit() {
    this.getLotteries();

    this.cartService.cartUpdated.subscribe((calculatedProduct) => {
      this.totalPrice = this.calculateTotalPrice(calculatedProduct);
      this.backPay = calculatedProduct.backPay;
      this.serviceFee = calculatedProduct.lottery.serviceFee;
      this.discount = calculatedProduct.discount;
      this.basePrice = calculatedProduct.defaultTotalPrice;

      const startDate = moment(calculatedProduct.lottery.start);
      this.lotteryNumber = this.cartService.getLotteryNumber();
      this.lotteryStartDate = startDate.format('DD.MM.YYYY');

      this.outputOnlyTotal();
      this.outputPriceDetails();
    });

    this.observeCouponField();

    this.checkoutService.getMe().subscribe(
      (response) => {
        this.isLoggedIn = true;
        this.sharedService.setLoggedIn(true);
      },
      (error) => {
        this.isLoggedIn = false;
        this.sharedService.setLoggedIn(false);
      }
    );

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.isConfirmation = event.url === '/bestellen/bestaetigung';
        const formContainer = document.querySelector('.lp-form-container');
        const formHeading = document.querySelector('#lp-form-heading-count');

        if (!formContainer || !formHeading) return;

        if (this.isConfirmation) {
          formContainer['style'].display = 'none';
          formHeading['style'].display = 'none';
        } else {
          formContainer['style'].display = 'block';
          formHeading['style'].display = 'block';
        }
      }
    });
  }

  getLotteries(): void {
    this.httpService.getLotteries().subscribe((response) => {
      this.lotteries = this.cartService.getProductsWithAmount(response);
      this.cartService.setLottery(response);

      // Get product and ticketAmount from URL if set.
      const products = this.sharedService.getUrlParamByName('product');
      const ticketAmount = this.sharedService.getUrlParamByName('ticketamount');

      // If product and ticket amount is prefilled via URL (e.g. url.com?product=20&product=22&ticketamount=5&ticketamount=6)
      // then loop through all the products and prefill the select inputs.
      if (products && ticketAmount) {
        for (let i = 0; i < products.length; i++) {
          const product = parseInt(products[i], 10);
          const amount = parseInt(ticketAmount[i], 10);

          this.prefillProductFromUrlParams(product, amount);
        }
      }

      this.fillSelectWithValues();
      this.prefillCoupon();
    });
  }

  observeCouponField(): void {
    const couponField = <HTMLInputElement>document.getElementById('coupon');
    const couponClear = <HTMLElement>document.getElementById('couponClear');

    couponField.addEventListener('keyup', (event) => {
      if (event.target['value'] && event.target['value'].length > 0) {
        couponClear.style.display = 'block';
      } else {
        couponClear.style.display = 'none';
      }
    });

    couponField.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        this.setCoupon(event.target['value']);
      }
    });
  }

  calculateTotalPrice(product) {
    let total;

    // When no products are selected, the serviceFee should not be added.
    // When price is smaller than 0 (can happen because of discount) it should
    // also be displayed 0 and not -x.
    if (
      Math.round(product.price + product.lottery.serviceFee) <= 0 ||
      (product.price === 0 && product.products.length === 0)
    ) {
      total = 0;
    } else {
      total = product.price + product.lottery.serviceFee;
    }
    return total;
  }

  prefillCoupon() {
    // Get coupon data from session storage
    const storedCouponData: CouponFieldData =
      this.sharedService.getSessionStorage('couponData');

    if (storedCouponData && storedCouponData.code) {
      const couponField = ((<HTMLInputElement>(
        document.getElementById('coupon')
      )).value = storedCouponData.code);
    }

    // Submit coupon form and hide it if successfully when
    // a coupon code is set via config or via coupon-set
    if (
      storedCouponData &&
      storedCouponData.code &&
      (this.sharedService.getCookie('coupon-set') ||
        this.sharedService.getSiteConfig().coupon)
    ) {
      this.setCoupon(storedCouponData.code, true);
    } else if (
      storedCouponData &&
      storedCouponData.code &&
      storedCouponData.submitted
    ) {
      this.setCoupon(storedCouponData.code, false);
    }
  }

  /*
   * @param {Number} productId
   * @paramt {Number} ticketAmount
   *
   * Select the product passed in via param and adds the product to cart.
   */
  prefillProductFromUrlParams(productId: number, ticketAmount: number): void {
    const product = this.findProductById(this.lotteries.products, productId);
    product.amount = ticketAmount;

    // Only add product if amount is greater 0
    if (ticketAmount > 0) {
      this.cartService.addProduct(product, this.lotteries.odds);
    }
  }

  /*
   * @param {Object} event
   *
   * This method is called when the user selects a ticket amount
   * in the select element.
   */
  onTicketSelect(event) {
    // Get product details from elements data-attribute to pass it to cartService later.
    const product = JSON.parse(event.currentTarget.dataset.product);
    product.amount = parseInt(event.currentTarget.value, 10);

    // Either remove or add a product depending on the select amount
    if (parseInt(event.currentTarget.value, 10) === 0) {
      this.cartService.removeProduct(product, []);
    } else {
      this.cartService.addProduct(product, this.lotteries.odds);
    }
  }

  fillSelectWithValues(): void {
    // Get all selects elements on landing page
    const selects = document.querySelectorAll('select[data-productid]');

    // Loop through all select eleements on landing pages
    // and fill them with possible <option>'s values based on
    // available products.
    Array.from(selects).forEach((select) => {
      select.innerHTML = '';

      // Get product ID from data-attribute in each select field. Every select field
      // needs to have this attribute to determine what product it should display.
      const productId = select.getAttribute('data-productid');

      // Get the actual product details by the select's product ID.
      const product = this.findProductById(this.lotteries.products, productId);

      const hideZero = select.getAttribute('data-hidezero');
      const initialValue = select.getAttribute('data-initialvalue');

      // Pass product details as JSON string to select element's data-attribute
      // to work with it when user selects a product and ticket amount.
      // (These details then need to be passed to cartService later)
      select.setAttribute('data-product', JSON.stringify(product));

      // Loop through product.maxQuantity and create the option elements
      for (let i = 0; i <= product.maxQuantity; i++) {
        if (hideZero && i === 0) {
          continue;
        }
        const optionElement = document.createElement('option');
        const productAmount = i;
        const productPrice = product.price * productAmount;
        const optionText = this.getOptionText(productAmount, product);
        const onlyText = productAmount > 0 ? 'nur ' : '';

        optionElement.textContent =
          productAmount +
          ' ' +
          optionText +
          ' (' +
          onlyText +
          productPrice.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR'
          }) +
          ')';
        optionElement.value = productAmount.toString();

        select.appendChild(optionElement);
      }

      this.setInitialValue(select, product, hideZero, initialValue);
    });
  }

  /**
   *
   * @param productAmount
   * @param product
   *
   * Since the options can contain full "Lose" or "Los-Anteile",
   * we need to decide by checking the product.id what text to
   * display in the select dropdown.
   */
  getOptionText(productAmount: number, product): String {
    const lotteryParts: String[] = ['13', '14'];
    const lotteryFull: String[] = ['15', '16', '17'];

    let text: String = '';

    if (lotteryFull.includes(product.id) && productAmount === 1) {
      text = 'Los';
    } else if (lotteryFull.includes(product.id) && productAmount !== 1) {
      text = 'Lose';
    } else if (lotteryParts.includes(product.id) && productAmount === 1) {
      text = 'Los-Anteil';
    } else if (lotteryParts.includes(product.id) && productAmount !== 1) {
      text = 'Los-Anteile';
    }

    return text;
  }

  setInitialValue(element, product, hideZero, initialValue) {
    if (hideZero && product.amount === 0 && !initialValue) {
      product.amount = 1;
      this.cartService.addProduct(product, this.lotteries.odds);
    }

    if (initialValue && product.amount === 0) {
      product.amount = initialValue;
      this.cartService.addProduct(product, this.lotteries.odds);
    }

    (<HTMLInputElement>element).value = product.amount;

    const addToCartExists = sessionStorage.getItem('addToCart');
    if (!addToCartExists) {
      this.sharedService.pushCustomToDataLayer({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          value: this.cartService.getTotalPriceWithoutDiscount(),
          items: this.cartService.getProductsForGTMTracking()
        }
      });
    }
  }

  outputOnlyTotal(): void {
    const externalSummary = document.getElementById('ticketSummary');

    if (externalSummary) {
      externalSummary.innerHTML = this.totalPrice.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR'
      });
    }
  }

  outputPriceDetails(): void {
    const priceDetailsElement = document.querySelector('.gl-pricingContainer');

    const landingPageId = this.sharedService.getSiteConfig().landingPageId;

    if (priceDetailsElement) {
      let priceDetails;

      if (this.totalPrice <= 0 && this.discount > 0) {
        priceDetails = `
                <span class="gl-pricingContainer__topline">Gesamtpreis im 1. Monat</span>
                <span class="gl-pricingContainer__price">kostenlos</span>
                <span class="gl-pricingContainer__fullPrice">Preis ab dem 2. Monat: ${this.basePrice.toLocaleString(
                  'de-DE',
                  {
                    style: 'currency',
                    currency: 'EUR'
                  }
                )}</span> `;
      } else {
        const totalPriceText =
          this.discount > 0
            ? `Gesamtpreis im 1. Monat`
            : 'Gesamtpreis im Monat';
        priceDetails = `
            <span>${totalPriceText}:</span>
            <span class="gl-pricingContainer__price">nur ${this.totalPrice.toLocaleString(
              'de-DE',
              {
                style: 'currency',
                currency: 'EUR'
              }
            )}</span> `;

        if (this.discount > 0) {
          priceDetails += `<span class="gl-pricingContainer__fullPrice">Preis ab dem 2. Monat: nur ${this.basePrice.toLocaleString(
            'de-DE',
            {
              style: 'currency',
              currency: 'EUR'
            }
          )}</span> `;
        }
      }

      if (this.totalPrice > 0 || this.discount > 0) {
        const serviceFeeAddition = this.serviceFee === 0 ? 'zzgl.' : 'inkl.';
        priceDetails += `<span class="gl-pricingContainer__fee">Alle Preise ${serviceFeeAddition} ${this.serviceFee.toLocaleString(
          'de-DE',
          {
            style: 'currency',
            currency: 'EUR'
          }
        )} <span title="Pro Monat fällt eine Servicepauschale * inkl. gesetzl. MwSt. von ${this.serviceFee.toLocaleString(
          'de-DE',
          {
            style: 'currency',
            currency: 'EUR'
          }
        )} an, um die Kosten für Bearbeitung, Amtliche Gewinnlisten, Kundenservice und die Verwaltung Ihres Kundenkontos zu decken." uk-tooltip="pos: bottom">Servicepauschale * inkl. gesetzl. MwSt. <span class="uk-margin-small-left uk-text-muted" uk-icon="info"></span></span></span> `;
      }

      if (this.backPay > 0) {
        priceDetails += `<span class="gl-pricingContainer__backpay">zzgl. einmalige Nachzahlung von ${this.backPay.toLocaleString(
          'de-DE',
          {
            style: 'currency',
            currency: 'EUR'
          }
        )} <span title="Die ${this.lotteryNumber}. Lotterie hat bereits am ${
          this.lotteryStartDate
        } begonnen. Sie haben noch die Möglichkeit in die laufende Lotterie einzusteigen. Für bereits abgelaufene Klassen müssen Sie Ihren Einsatz nachentrichten. Dies gilt nicht für die Joker Spiele."></i></span></span>`;
      }

      priceDetailsElement.innerHTML = priceDetails;
    }
  }

  showCouponResponse(responseMsg, type): void {
    const successElement = <HTMLInputElement>(
      document.querySelector('.uk-alert-success')
    );
    const errorElement = <HTMLInputElement>(
      document.querySelector('.uk-alert-warning')
    );

    if (errorElement && successElement) {
      successElement.style.display = 'none';
      errorElement.style.display = 'none';

      if (type === 'success') {
        successElement.querySelector(
          'p'
        ).innerHTML = `<i class="uk-margin-small-right" uk-icon="check"></i> Der Gutscheincode ${responseMsg.code} wurde erfolgreich eingelöst.`;
        successElement.style.display = 'block';
      } else {
        errorElement.querySelector(
          'p'
        ).innerHTML = `<i class="uk-margin-small-right" uk-icon="ban"></i>  ${responseMsg}`;
        errorElement.style.display = 'block';
      }
    }
  }

  hideCouponResponse() {
    const successElement = <HTMLInputElement>(
      document.querySelector('.uk-alert-success')
    );
    const errorElement = <HTMLInputElement>(
      document.querySelector('.uk-alert-warning')
    );

    successElement.style.display = 'none';
    errorElement.style.display = 'none';
  }

  setCoupon(coupon, isPrefilled = false) {
    const couponField = (<HTMLInputElement>document.getElementById('coupon'))
      .value;
    const couponClear = <HTMLElement>document.getElementById('couponClear');
    const code = typeof coupon === 'string' ? coupon : couponField;
    const couponData = {
      code: code,
      products: this.cartService.getProductsForOrder()
    };
    const submitId = this.sharedService.generateRandomHash();

    this.checkoutService.validateCoupon(couponData).subscribe(
      (response) => {
        // Set coupon in sessionStorage if coupon is correct
        this.sharedService.setSessionStorage('couponData', {
          code: couponData.code,
          submitted: true
        });

        // Set discount via cartService
        this.cartService.setDiscount(response.discount, response.code);

        // Update UI
        this.showCouponResponse(response, 'success');
        this.hideCouponField(isPrefilled);
        this.showPriceField();

        this.sharedService.pushCustomToDataLayer(
          {
            event: 'coupon success',
            category: submitId
          },
          false
        );

        this.showFormIfHidden();
      },
      (error) => {
        this.showCouponResponse(error.error.msgs[0], 'error');
        this.cartService.setDiscount(0, '');
        this.sharedService.removeFromSessionStorage('couponData');
        this.sharedService.pushErrorToDataLayer(error.error[0], submitId);
        couponClear.style.display = 'block';
      }
    );
  }

  clearCoupon(clearedCoupon): void {
    const couponField = <HTMLInputElement>document.getElementById('coupon');
    const couponClear = <HTMLElement>document.getElementById('couponClear');
    this.cartService.setDiscount(0, '');
    this.sharedService.removeFromSessionStorage('couponData');
    this.hideCouponResponse();
    couponField.value = '';
    couponField.focus();
    couponClear.style.display = 'none';
  }

  hideCouponField(isPrefilled) {
    const couponElement = <HTMLInputElement>(
      document.getElementById('couponWrapper')
    );

    if (isPrefilled && couponElement) {
      couponElement.style.display = 'none';
    }
  }

  showPriceField() {
    const ticketSummary = <HTMLInputElement>(
      document.getElementById('ticketSummary')
    );

    const pricingContainer = <HTMLInputElement>(
      document.querySelector('.gl-pricingContainer')
    );

    if (ticketSummary) {
      ticketSummary.style.display = 'block';
    }

    if (pricingContainer) {
      pricingContainer.style.display = 'block';
    }
  }

  showFormIfHidden() {
    const formWrapper = <HTMLInputElement>(
      document.getElementById('landingHider')
    );

    if (formWrapper) {
      formWrapper.style.display = 'block';
    }
  }

  findProductById(allProducts, productId) {
    return allProducts.filter(
      (product) => parseInt(product.id, 10) === parseInt(productId, 10)
    )[0];
  }
}
